import { Token } from "../types/Token";
import { bsc, bscTestnet } from "viem/chains";

export const tokenList: Token[] = [
  {
    chainId: bscTestnet.id,
    address: bscTestnet.contracts.multicall3.address,
    name: "Binance Coin Testnet",
    symbol: "BSC",
    decimals: 18,
    logoURI: "/images/tokens/bnb.svg",
  },
  {
    chainId: bsc.id,
    address: "0x337610d27c682e347c9cd60bd4b3b107c9d34ddd",
    name: "Binance Coin",
    symbol: "BNB",
    decimals: 18,
    logoURI: "/images/tokens/bnb.svg",
  },
];

export const BNBtoken = tokenList.find((token) => token.symbol === "BNB");
export const BSCtoken = tokenList.find((token) => token.symbol === "BSC");
